module.exports = (angularModule) => {

  angularModule.controller("AccountCreatorCtrl", AccountCreatorCtrl);

  AccountCreatorCtrl.$inject = ['$log', '$stateParams', '$location', 'pageInfo', 'accountsService','stringService','updateService'];
  function AccountCreatorCtrl($log, $stateParams, $location, pageInfo, accountsService, stringService, updateService) {
    var vm = this;

    vm.state = 'AccountEditing';
    vm.account = {accountName: ''};
    vm.errorMsg = '';
    vm.mode = pageInfo.mode;

/*    vm.accountConfig = {
      required : false,
      accountId : accountsService.getCurrentAccount(),
      showAccountSelection: false,
      editPage: true
    }*/

    vm.createEditAccount = function (formIsValid) {
      vm.pendingResponse = true;
      vm.state = "PendingConfirmation";

      vm.formSubmitted = true;
      if(!formIsValid){
        vm.errorMsg = 'The form is missing some data!';
        return;
      }

      if(vm.mode=="create"){
      accountsService.createAccount(vm.account.accountName, vm.account.clientAccountId).then(handleCreatedAccount, handleAccountCreationError);
      }
      else if(vm.mode=="edit"){
      accountsService.updateAccount(vm.account).then(handleCreatedAccount, handleAccountCreationError);
      }
    };

    vm.processSuccessfulAccountUpdate = function(response){

      var updateInfo = {
        status: "Active",
        type: "account",
        title: "Account",
        destinationRole: "manage",
        notificationType: "detail",
        actions: [{action:vm.mode}],
        name: vm.newAccount.accountName,
        searchParam: vm.newAccount.accountName,
        id: vm.newAccount.id
      }
      updateService.registerSuccessfulUpdate(updateInfo);
      $location.path('/admin/v2/accounts');
    }

    function handleCreatedAccount(resp) {
      vm.newAccount = resp.data;
      vm.processSuccessfulAccountUpdate(resp);
      accountsService.needsRefresh = true;
      vm.state = 'Success';
    }

    vm.pageStrings = stringService.adminStrings(vm.mode);

    function handleAccountCreationError(response) {
      $log.error(response);
      var errorDetail = 'Please contact support';

      if(response.data && response.data.error.code) {
        vm.state = "AccountEditing";
        vm.pendingResponse = false;
        var errorCode = response.data.error.code;

        if(errorCode === 'accounts.edit.accountName.duplicate'){
          errorDetail = 'This account name already exists. Account names must be unique.';
        } else if(errorCode === 'accounts.edit.clientAccountId.duplicate') {
          errorDetail = 'This Client Account Id already exists. Client Account Ids must be unique.';
        }
      }

      vm.errorMsg = 'Error '+vm.pageStrings.errorAction+' account! ' + errorDetail;

    }

    vm.hasError = function (input) {
      if (!input) return;
      return input.$invalid && (!input.$pristine || vm.formSubmitted);
    };

    activate();

    function activate() {
      vm.state = 'Loading';
      if(vm.mode == "create"){
        vm.state = 'AccountEditing';
      }
      else if(vm.mode == "edit"){
        accountsService.getAccount($stateParams.accountId).then(function(resp){
          vm.state = 'AccountEditing';
          vm.account = resp.data;
        })
      }
      //No activation required
    }
  }
}
